import type { ModelError } from "@iot-platform/core";
import { NonRecuperableModelError } from "@iot-platform/core";
import type { RouteDto, RouteStatusEnumDto } from "@station/data/dto/route.dto";
import { RouteDtoSchema } from "@station/data/dto/route.dto";
import { Route, RouteStatusEnum } from "@station/domain/models/route.model";
import { injectable } from "inversify";
import { err, Result } from "neverthrow";

const ROUTE_STATUS_BY_DTO: Readonly<
    Record<RouteStatusEnumDto, RouteStatusEnum>
> = {
    PARADA: RouteStatusEnum.PARADA,
    DESPLAZAMIENTO: RouteStatusEnum.DESPLAZAMIENTO,
};

@injectable()
export class RouteMapper {
    map(routeDto: RouteDto): Result<Route, ModelError<typeof Route>> {
        const routeDtoParsed = RouteDtoSchema.safeParse(routeDto);

        if (!routeDtoParsed.success) {
            console.error(routeDtoParsed.error.issues);
            return err(new NonRecuperableModelError());
        }

        const stationEntries = Object.entries(routeDtoParsed.data.data);
        const stationData = stationEntries[0];

        if (!stationEntries.length || !stationData) {
            return err(new NonRecuperableModelError());
        }

        const stationObj = stationData[1];

        const routeProps = {
            tracks: stationObj.tracks.map((track) => ({
                timestamp: track.timestamp,
                status: track.status ? ROUTE_STATUS_BY_DTO[track.status] : null,
                position: track.position,
                latitude: track.latitude,
                longitude: track.longitude,
                values: track.values,
            })),
            roads: stationObj.roads,
        };

        return Route.createWithRecovery(routeProps).mapErr((error) => {
            console.error(error);
            return new NonRecuperableModelError();
        });
    }
}
